export * from './components/index';
export * from './gift-form';
export * from './coupon';
export * from './super-coupon';
export * from './vendors';
export * from './share';
export * from './locations';

console.log('bundle initialized.');
